import { RootState } from '@/store';
import { ProductsImportState, GENERATED_QR_SLICE_NAME } from './models';

export const generatedQrSelector = (state: RootState): ProductsImportState => state[GENERATED_QR_SLICE_NAME];
